import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaAssociadoQuantidade.vue?vue&type=template&id=73ed198f"
import script from "./ModalSolicitacaoCirurgiaAssociadoQuantidade.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaAssociadoQuantidade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports